import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import TkProcessTempleteDialog from '../dialogTypes/TkProcessTempleteDialog';

function TkProcessTempleteCreateButton ( props ) {

    const { t } = useTranslation();

    const { id, schema, onSuccess, api, ...others } = props;

    const [ open, setOpen ] = useState(false);

    const onOpen = () => {

        setOpen ( true );

    };

    const onClose = () => {

        setOpen ( false );

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );
            
        }

        if(api) {

            api.refresh();
        }
    };

    return (

        <>
            <CreateRecordButtonLayout id={id+"create-button"} onClick={onOpen} {...others} />
            <TkProcessTempleteDialog
                id={id+"create-dialog"}
                mode="create"
                formId={id+"create-form"}
                title={ schema ? t ( `dialog.title.${schema.name}.create` ) : "" }
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>

    );
}

export default TkProcessTempleteCreateButton;

